import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiUrlConstant } from 'src/app/constants/api-url.constant';
import { RestApiService } from '../rest/rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class WhatsAppService extends RestApiService {

  apiUrl = ApiUrlConstant.apiUrl;

  sendWelcomeMessage(isdCode: string, phoneNumber: any,firstName:any,lastName:any): Observable<any> {
    let obj = {
      "assessmentsUrl": window.location.origin+'/assesments',
      "isdCode": isdCode,
      "liveClassesUrl": "Live classes will be launching soon",
      "name": firstName+' '+lastName,
      "phone": phoneNumber
    }
    const url = this.apiUrl + `/api/whatsapp/welcomemessage`;
    return this.post<any>(url,obj);
  }
}
